import React from "react";

const inputClass = "w-full bg-bone border border-border_custom px-4 py-3 text-text_main placeholder-text_muted/50 focus:border-emerald_deep focus:outline-none transition-colors rounded-lg text-sm";

export default function ClientDetailsForm({ formData, setFormData }) {
  return (
    <div className="bg-surface border border-border_custom p-6 mb-6 rounded-xl">
      <div className="space-y-5">
        <div>
          <label className="block text-sm text-emerald_deep mb-2 tracking-wider">Full Name *</label>
          <input type="text" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            placeholder="Enter your full name" data-testid="consultation-name" className={inputClass} />
        </div>
        <div>
          <label className="block text-sm text-emerald_deep mb-2 tracking-wider">Email Address *</label>
          <input type="email" value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            placeholder="Enter your email" data-testid="consultation-email" className={inputClass} />
        </div>
        <div>
          <label className="block text-sm text-emerald_deep mb-2 tracking-wider">Phone Number *</label>
          <input type="tel" value={formData.phone} onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
            placeholder="Enter your phone number" data-testid="consultation-phone" className={inputClass} />
        </div>
        <div>
          <label className="block text-sm text-emerald_deep mb-2 tracking-wider">Alternate Phone Number</label>
          <input type="tel" value={formData.alt_phone} onChange={(e) => setFormData({ ...formData, alt_phone: e.target.value })}
            placeholder="Optional" data-testid="consultation-alt-phone" className={inputClass} />
        </div>
        <div>
          <label className="block text-sm text-emerald_deep mb-2 tracking-wider">Main Health Concern *</label>
          <textarea value={formData.health_concern} onChange={(e) => setFormData({ ...formData, health_concern: e.target.value })}
            placeholder="Describe your primary health concern..." rows={3} data-testid="consultation-health-concern" className={`${inputClass} resize-none`} />
        </div>
      </div>
    </div>
  );
}
